// Wellness Matrix USA — Blog nav links open in new tab
document.addEventListener('DOMContentLoaded', function () {
  var allLinks = document.querySelectorAll('a[href*="/blogs/"]');
  allLinks.forEach(function (link) {
    var isNav = link.closest('nav, header, [class*="nav"], [class*="header"], [class*="menu"]');
    if (isNav) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    }
  });
});
